import type { ReportTemplate } from 'features/reporting/types'
import {
  VisualReportContext,
  VisualReportProvider,
} from 'pages/reporting/reports/externalVisual/VisualReportProvider'
import {
  FfsReportContext,
  FfsReportProvider,
} from 'pages/reporting/reports/ffs/FfsReportProvider'
import {
  RautReportContext,
  RautReportProvider,
} from 'pages/reporting/reports/raut/RautReportProvider'
import {
  RugReportContext,
  RugReportProvider,
} from 'pages/reporting/reports/rug/RugReportProvider'
import { GeckoComponentModelType, isEnum } from 'types'

export enum ReportTemplateId {
  ADVANCED_SERVICES = 'advancedServicesTemplate',
  EXTERNAL_VISUAL = 'externalVisualTemplate',
  RUG = 'rugTemplate',
  FFS = 'ffsTemplate',
}

export const isReportTemplateId = isEnum<ReportTemplateId>(ReportTemplateId)

export const ReportTemplates: Record<ReportTemplateId, ReportTemplate> = {
  [ReportTemplateId.ADVANCED_SERVICES]: {
    supportedComponentTypes: [
      GeckoComponentModelType.PipeSection,
      GeckoComponentModelType.PressureVesselShell,
      GeckoComponentModelType.PipeElbow,
      GeckoComponentModelType.HemisphericalHead,
      GeckoComponentModelType.TorisphericalHead,
      GeckoComponentModelType.EllipsoidalHead,
    ],
    supportedInspectionTypes: ['raut', 'phased-array'],
    canSupportMultipleInspections: true,
    reportContext: RautReportContext,
    providerComponent: RautReportProvider,
    reportName: 'Advanced Services',
  },
  [ReportTemplateId.EXTERNAL_VISUAL]: {
    supportedComponentTypes: [],
    supportedInspectionTypes: ['external-visual'],
    canSupportMultipleInspections: false,
    reportContext: VisualReportContext,
    providerComponent: VisualReportProvider,
    reportName: 'External Visual',
  },
  [ReportTemplateId.RUG]: {
    supportedComponentTypes: [
      GeckoComponentModelType.VerticalTankShell,
      GeckoComponentModelType.TankFloor,
      GeckoComponentModelType.TankFlatRoof,
      GeckoComponentModelType.LegacyBoilerWalls,
      GeckoComponentModelType.LegacyCone,
    ],
    supportedInspectionTypes: ['rug', 'manual'],
    canSupportMultipleInspections: true,
    reportContext: RugReportContext,
    providerComponent: RugReportProvider,
    reportName: 'RUG',
  },
  [ReportTemplateId.FFS]: {
    supportedComponentTypes: [
      GeckoComponentModelType.PipeSection,
      GeckoComponentModelType.PipeElbow,
      GeckoComponentModelType.PressureVesselShell,
      GeckoComponentModelType.HemisphericalHead,
      GeckoComponentModelType.TorisphericalHead,
      GeckoComponentModelType.EllipsoidalHead,
    ],
    supportedInspectionTypes: ['raut'],
    canSupportMultipleInspections: true,
    reportContext: FfsReportContext,
    providerComponent: FfsReportProvider,
    reportName: 'FFS Assessment',
  },
}
